// Dermatology Treatment Options
import {basePdfUrl} from '../../../../../api/api';

const treatmentOptionsToDermatology = basePdfUrl + 'to/dermatology/';

export const treatmentOptionsDermatologyData = [
  {
    id: 0,
    title: 'Dermatitis and Urticaria',
    pdf_link:
      treatmentOptionsToDermatology +
      '2-Dermatitis-and-Urticaria-Treatment.pdf',
  },
  {
    id: 1,
    title: 'Lupus',
    pdf_link: treatmentOptionsToDermatology + '2-Lupus-Treatment.pdf',
  },
  {
    id: 2,
    title: 'Acne',
    pdf_link: treatmentOptionsToDermatology + 'Acne-Treatment-Options.pdf',
  },
  {
    id: 3,
    title: 'Anogenital Warts',
    pdf_link:
      treatmentOptionsToDermatology + 'Anogenital-Warts-Treatment-Options-.pdf',
  },
  {
    id: 4,
    title: 'Psoriasis',
    pdf_link: treatmentOptionsToDermatology + 'Psoriasis-Treatment.pdf',
  },
  {
    id: 5,
    title: 'Rosacea',
    pdf_link: treatmentOptionsToDermatology + 'Rosacea-Treatment-Options-.pdf',
  },
  {
    id: 6,
    title: 'Skin Cancer',
    pdf_link: treatmentOptionsToDermatology + 'Skin-Cancer-Treatment.pdf',
  },
  {
    id: 7,
    title: 'Tinea Infection',
    pdf_link:
      treatmentOptionsToDermatology + 'TINEA-INFECTION-TREATMENT-OPTION.pdf',
  },
  {
    id: 8,
    title: 'Varicella Zoster Virus',
    pdf_link:
      treatmentOptionsToDermatology +
      'Varicella-Zoster-Virus-TREATMENT-OPTIONS.pdf',
  },
  {
    id: 9,
    title: 'Vitiligo',
    pdf_link: treatmentOptionsToDermatology + 'Vitiligo-Treatment-Options.pdf',
  },
];
